declare namespace $ {

	export class $mol_icon_thumb_down extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=down.view.tree.d.ts.map